"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ReviewAppt;
var _react = _interopRequireDefault(require("react"));
var _propTypes = require("prop-types");
var _xstate = require("xstate");
var _react2 = require("@xstate/react");
var _States = require("../../lib/constants/States");
var _ReviewAndBookHeader = require("./ReviewAndBookHeader");
var _AppointmentDetails = require("./AppointmentDetails");
var _PatientDetails = require("./PatientDetails");
var _BookingRedirectDetails = _interopRequireDefault(require("./BookingRedirectDetails"));
var _styles = require("./styles");
var _useWindowWidth = _interopRequireDefault(require("../../lib/useWindowWidth"));
var _propTypes2 = require("../../lib/propTypes");
const detailsFromPatientRegistration = _ref => {
  let {
    patient,
    appointment: {
      notes,
      insurance: {
        plan_name
      } = {}
    } = {}
  } = _ref;
  const details = {
    name: `${patient.name.first} ${patient.name.last}`,
    dob: patient.dob,
    email: patient.email,
    phoneNumber: patient.phone.number
  };
  if (notes) details.notes = notes;
  if (plan_name) details.insurance = plan_name;
  return details;
};
const propTypes = {
  bodyIsAnimating: _propTypes.bool,
  config: _propTypes2.configType,
  onScroll: _propTypes.func,
  service: (0, _propTypes.instanceOf)(_xstate.Interpreter).isRequired,
  track: _propTypes.func.isRequired
};
function ReviewAppt(_ref2) {
  let {
    bodyIsAnimating,
    config,
    onScroll,
    service,
    track
  } = _ref2;
  const [state] = (0, _react2.useService)(service);
  const {
    provider,
    selectedAppointment,
    location,
    patientRegistration
  } = state.context;
  const {
    aboveMd: hideApptDetails
  } = (0, _useWindowWidth.default)();
  let details;
  if (!state.matches(_States.apptUnavailable)) {
    if (hideApptDetails) {
      details = /*#__PURE__*/_react.default.createElement(_PatientDetails.PatientDetails, detailsFromPatientRegistration(patientRegistration));
    } else {
      details = /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_AppointmentDetails.AppointmentDetails, {
        provider: provider,
        appointment: selectedAppointment,
        location: location
      }), /*#__PURE__*/_react.default.createElement(_PatientDetails.PatientDetails, detailsFromPatientRegistration(patientRegistration)));
    }
  } else {
    details = /*#__PURE__*/_react.default.createElement(_BookingRedirectDetails.default, {
      service: service
    });
  }
  return /*#__PURE__*/_react.default.createElement(_styles.ReviewAndBookContainer, {
    "data-testid": "ReviewAppt"
  }, /*#__PURE__*/_react.default.createElement(_ReviewAndBookHeader.ReviewAndBookHeader, {
    bodyIsAnimating: bodyIsAnimating,
    config: config,
    onScroll: onScroll,
    service: service,
    track: track
  }), /*#__PURE__*/_react.default.createElement(_styles.DetailsContainer, null, details));
}
ReviewAppt.propTypes = propTypes;
ReviewAppt.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "ReviewAppt",
  "props": {
    "bodyIsAnimating": {
      "description": "",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "config": {
      "description": "",
      "type": {
        "name": "custom",
        "raw": "configType"
      },
      "required": false
    },
    "onScroll": {
      "description": "",
      "type": {
        "name": "func"
      },
      "required": false
    },
    "service": {
      "description": "",
      "type": {
        "name": "instanceOf",
        "value": "Interpreter"
      },
      "required": true
    },
    "track": {
      "description": "",
      "type": {
        "name": "func"
      },
      "required": true
    }
  }
};